import React from 'react';
import { PencilIcon, SaveIcon, XIcon, RefreshIcon, CheckIcon, FastForwardIcon, TrashIcon } from '@heroicons/react/solid';

// Simple presentational component that renders the floating action panel UI.
//
// Responsibilities:
// - Display the consistent action buttons across review pages
// - Accept an external ref (panelRef) so the positioning hook can update
//   top/left styles directly on the DOM node while editing.
// - Do not implement any positioning or business logic itself.
export function FloatingActionPanel({
  panelRef,
  position,
  visible,
  isEditing,
  hasBeenModified,
  onStartEdit,
  onSave,
  onCancel,
  onReset,
  onApprove,
  onSkip,
  onDelete,
  canDelete,
}) {
  if (!visible) return null;

  return (
    <div
      ref={panelRef}
      data-action-panel
      className={`
        absolute z-20 bg-gray-100 rounded-xl shadow border-2 border-gray-300 p-2
        transition-all duration-300 ease-in-out
      `}
      style={{
        top: `${position.top}px`,
        left: `${position.left}px`,
        transform: 'translateX(-100%) translateY(8px)',
      }}
    >
      <div className="font-bold flex items-center gap-2">
        {isEditing ? (
          <>
            <button
              onClick={onSave}
              className="px-2 py-1 rounded-lg text-sm flex items-center justify-center bg-amber-200 hover:bg-amber-300 border border-gray-300"
            >
              <SaveIcon className="w-5 h-5 mr-1" />
              Save
            </button>
            <button
              onClick={onCancel}
              className="px-2 py-1 rounded-lg text-sm flex items-center justify-center bg-red-500 text-white hover:bg-red-600"
            >
              <XIcon className="w-5 h-5 mr-1" />
              Cancel
            </button>
            {hasBeenModified && (
              <button
                onClick={onReset}
                className="px-2 py-1 rounded-lg text-sm flex items-center justify-center bg-black text-white hover:bg-gray-800"
              >
                <RefreshIcon className="w-5 h-5 mr-1" />
                Reset
              </button>
            )}
          </>
        ) : (
          <>
            {canDelete && (
              <button
                onClick={onDelete}
                className="px-2 py-1 rounded-lg text-sm flex items-center justify-center bg-red-100 text-red-700 hover:bg-red-200 border border-red-300"
              >
                <TrashIcon className="w-5 h-5 mr-1" />
                Delete
              </button>
            )}
            <button
              onClick={onStartEdit}
              className="px-2 py-1 rounded-lg text-sm flex items-center justify-center bg-amber-200 hover:bg-amber-300 border border-gray-300"
            >
              <PencilIcon className="w-5 h-5 mr-1" />
              Edit
            </button>
            <button
              onClick={onApprove}
              className="px-2 py-1 rounded-lg text-sm flex items-center justify-center bg-green-600 text-white hover:bg-green-500"
            >
              <CheckIcon className="w-5 h-5 mr-1" />
              Approve
            </button>
            <button
              onClick={onSkip}
              className="px-2 py-1 rounded-lg text-sm flex items-center justify-center bg-gray-100 hover:bg-gray-200 border border-gray-300"
            >
              <FastForwardIcon className="w-5 h-5 mr-1" />
              Skip
            </button>
          </>
        )}
      </div>
    </div>
  );
}


